
import React, { useState } from 'react';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';
import SupportManagementPage from '@/components/support/SupportManagementPage';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { logoutUser } from '@/utils/auth';

const MasterLicenseSupportManagement = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleLogout = async () => {
    try {
      setIsLoading(true);
      await logoutUser();
      toast({
        title: "Logged out",
        description: "You have been successfully logged out."
      });
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Error logging out:', error);
      toast({
        title: "Error",
        description: "Failed to log out. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <MasterLicenseLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      activeTab="support"
    >
      <SupportManagementPage />
    </MasterLicenseLayout>
  );
};

export default MasterLicenseSupportManagement;
